import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { storeRedirect as storeRedirectForm } from 'plantItemNew/redux/slices/formSlice';
import { storeCurrentPath as storeCurrentPathForm } from 'shared/redux/applicationSlice';
import { PagePath } from 'shared/constants/pagePath';

export const PrivateRoute = ({
  children,
  storeRedirect = false,
  redirectPath = undefined,
  storeCurrentPath = false,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const passwordlessOidc = useSelector((state) => state.passwordlessOidc);
  const { user: passwordLessUser, isLoadingUser } = passwordlessOidc;
  const userExists = passwordLessUser && !isLoadingUser;

  if (storeRedirect) {
    let path = redirectPath || location.pathname;

    setTimeout(() => {
      dispatch(storeRedirectForm(path));
    }, 0);
  }

  if (userExists || (passwordLessUser && !passwordLessUser.expired)) {
    if (storeCurrentPath) {
      setTimeout(() => {
        dispatch(storeCurrentPathForm(location.pathname));
      }, 0);
    }
    return children;
  } else {
    dispatch(storeRedirectForm(location.pathname));
    dispatch(storeCurrentPathForm(location.pathname));
    setTimeout(() => {
      navigate(PagePath.lnswIdpLogin, { replace: true });
    }, 1000);

    return <></>;
  }
};
